/**
 * Merge tags for CAPA approval assignment emails (sent to assigned approver).
 * Defaults live in dbo.CAPAConfig (ApprovalAssignmentEmail*Default).
 */
export const CAPA_APPROVAL_ASSIGNMENT_EMAIL_MERGE_TAGS = [
  { tag: "{{CapaNo}}", entityName: "CapaNo", description: "CAPA reference number" },
  { tag: "{{Title}}", entityName: "Title", description: "CAPA title" },
  {
    tag: "{{Description}}",
    entityName: "Description",
    description: "Approver assignment description (from CAPA)",
  },
  { tag: "{{ApproverName}}", entityName: "ApproverName", description: "Assigned approver display name" },
  { tag: "{{DueDate}}", entityName: "DueDate", description: "Approval due date" },
  { tag: "{{EntityLabel}}", entityName: "EntityLabel", description: "Linked context label (if any)" },
  { tag: "{{EntityType}}", entityName: "EntityType", description: "Linked entity type (if any)" },
  { tag: "{{OrganizationName}}", entityName: "OrganizationName", description: "Organization name (when available)" },
  { tag: "{{CapaUrl}}", entityName: "CapaUrl", description: "Deep link to open the CAPA in the app" },
];

/**
 * Merge tags when an approver accepts/rejects — email to CAPA owner.
 */
export const CAPA_APPROVAL_DECISION_EMAIL_MERGE_TAGS = [
  { tag: "{{CapaNo}}", entityName: "CapaNo", description: "CAPA reference number" },
  { tag: "{{Title}}", entityName: "Title", description: "CAPA title" },
  {
    tag: "{{Description}}",
    entityName: "Description",
    description: "Approver assignment description (from CAPA)",
  },
  {
    tag: "{{OwnerName}}",
    entityName: "OwnerName",
    description: "CAPA owner display name (email recipient)",
  },
  {
    tag: "{{ApproverName}}",
    entityName: "ApproverName",
    description: "Staff assigned as approver for this assignment",
  },
  {
    tag: "{{DecidedByName}}",
    entityName: "DecidedByName",
    description: "Staff who accepted or rejected the approval request",
  },
  { tag: "{{Decision}}", entityName: "Decision", description: "Accepted or Rejected" },
  {
    tag: "{{DecisionReason}}",
    entityName: "DecisionReason",
    description: "Reason entered when accepting or rejecting",
  },
  { tag: "{{DueDate}}", entityName: "DueDate", description: "Approval due date" },
  { tag: "{{EntityLabel}}", entityName: "EntityLabel", description: "Linked context label (if any)" },
  { tag: "{{EntityType}}", entityName: "EntityType", description: "Linked entity type (if any)" },
  { tag: "{{OrganizationName}}", entityName: "OrganizationName", description: "Organization name (when available)" },
  { tag: "{{CapaUrl}}", entityName: "CapaUrl", description: "Deep link to open the CAPA in the app" },
];

/**
 * @param {string} template
 * @param {Record<string, string>} values keys = entity names (e.g. CapaNo, Title)
 */
export function applyCapaApprovalEmailTemplate(template, values) {
  if (!template || !values) return template || "";
  let out = template;
  Object.keys(values).forEach((key) => {
    if (!key) return;
    out = out.split(`{{${key}}}`).join(values[key] != null ? String(values[key]) : "");
  });
  return out;
}
